<!-- 巨量引擎 计划 表格 -->
<template>
	<div class="table-box" >
		<!-- 表头 -->
		<div class="table-th" ref="table_th" :style="{'width': table_scroll_width + 'px'}">
			<div class="table-th-cell-sticky" style="display: flex;align-items: center;">
				<div class="table-th-cell"
				:style="{'width':30 + 'px'}">
					<a-checkbox :indeterminate="indeterminate" :checked="checkAll" @change="onCheckAllChange"></a-checkbox>
				</div>
				<template v-for="(item,index) in rableTitle" name="item.type">
					<div v-if="index <= sticky_index" class="table-th-cell" style="cursor: default;"
					:style="{'width':rableTitle[index].width + 'px'}" >
						{{rableTitle[index].title}}
					</div>
				</template>
				
			</div>
			
			<div  v-for="(item,index) in rableTitle" :key="index" >
	
				<div v-if="index > sticky_index && item.show_control" class="table-th-cell" 
				:style="{'width':item.width + 'px','cursor':item.sort_control?'pointer':'default','justify-content': item.text_right?'flex-end':''}"
				@click="sortClick(index)">
					{{item.title}}
					<div v-if="item.sort_control" style="display: flex;flex-direction: column;width: 12px;margin-left: 5px;">
						<a-icon type="caret-up" :style="{'color': item.sort_status === 2?'#1890ff':'#999'}" style="font-size: 12px;margin-bottom: -4px;" />
						<a-icon type="caret-down" :style="{'color': item.sort_status === 1?'#1890ff':'#999'}" style="font-size: 12px;" />
					</div>
				</div>
			</div>
			<!-- 占位，隔出一个空白区域 -->
			<div id="" style="padding:15px;"></div>
		</div>
		
		<!-- 总计 -->
		<div v-if="tableShowData.length > 0" class="table-td"  :style="{'width': table_scroll_width + 'px'}">
			<div class="table-td-cell-sticky" style="display: flex;align-items: center;">
				<!-- 选择 -->
				<div class="table-td-cell" :style="{'width':30 + 'px'}">
					
				</div>
				<div class="table-td-cell"
				:style="{'width':rableTitle[0].width + 'px'}">
					总计
				</div>
				<div  class="table-td-cell"
				:style="{'width':rableTitle[1].width + 'px'}">
					
				</div>
			</div>
			<template v-for="(z_tem,z_ndex) in rableTitle">
				<div v-if="z_ndex > sticky_index && z_tem.show_control && z_table_control.indexOf(z_tem.type) < 0 && b_table_control.indexOf(z_tem.type) < 0 && x_table_control.indexOf(z_tem.type) < 0 " class="table-td-cell"
				 :class="{'text-right': rableTitle[z_ndex].text_right}"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{tableSumData[z_tem.type] || 0}}
				</div>
				<div v-else-if="z_ndex > sticky_index && z_tem.show_control && z_table_control.indexOf(z_tem.type) > -1" class="table-td-cell"
				 :class="{'text-right': rableTitle[z_ndex].text_right}"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					
				</div>
				<div v-else-if="z_ndex > sticky_index && z_tem.show_control && b_table_control.indexOf(z_tem.type) > -1" class="table-td-cell"
				 :class="{'text-right': rableTitle[z_ndex].text_right}"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{tableSumData[z_tem.type]*100 | tableToFixed}}%
				</div>
				<div v-else-if="z_ndex > sticky_index && z_tem.show_control && x_table_control.indexOf(z_tem.type) > -1" class="table-td-cell"
				 :class="{'text-right': rableTitle[z_ndex].text_right}"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{tableSumData[z_tem.type] | tableToFixed}}
				</div>
			</template>
		</div>
		
		<!-- 表格内容 -->
		<div v-for="(item,index) in tableShowData" :key="item.id" class="table-td"  :style="{'width': table_scroll_width + 'px'}">
			<div class="table-td-cell-sticky" style="display: flex;align-items: center;">
				<!-- 选择 -->
				<div class="table-td-cell" :style="{'width':30 + 'px'}">
					<a-checkbox :checked="item.checked" @change="onChangeCheckbox($event,index)"></a-checkbox>
				</div>
				
				<template v-for="(z_tem,z_ndex) in rableTitle">
					<div v-if="z_ndex <= sticky_index && z_tem.type == 'promotion_name'"  
					@click='operation(1,item)' class="table-td-cell"
					:style="{'width':rableTitle[z_ndex].width + 'px'}"
					 style="color: #2F88FF;">
						{{item[z_tem.type]}}
					</div>
					
					<div v-else-if="z_ndex <= sticky_index && z_tem.type == 'cz'"  
					class="table-td-cell" style="display: flex;align-items: center;justify-content: space-between;"
					:style="{'width':rableTitle[z_ndex].width + 'px'}">
						<a-switch size="small" :checked="item.status_checked" default-checked @change="onStatusCheckbox($event,item)"  checked-children="启用" un-checked-children="暂停"/>
						<div @click="zhOperation(8,item)" class='cz-cell'>小时数据</div>
						<div @click="zhOperation(9,item)" class='cz-cell'>天数据</div>
					</div>
					
				</template>
			</div>
			<template v-for="(z_tem,z_ndex) in rableTitle">
				<div v-if="z_ndex > sticky_index && z_tem.show_control && y_table_control.indexOf(z_tem.type) < 0 && b_table_control.indexOf(z_tem.type) < 0 && x_table_control.indexOf(z_tem.type) < 0 && z_tem.type != 'status' && z_tem.type != 'report_config' && z_tem.type != 'link.report_per' && z_tem.type != 'link_id' && z_tem.type != 'admin_list'" class="table-td-cell"
				 :class="{'text-right': rableTitle[z_ndex].text_right}"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{item[z_tem.type] || 0}}
				</div>
				<div v-else-if="z_ndex > sticky_index && z_tem.show_control && b_table_control.indexOf(z_tem.type) > -1" class="table-td-cell"
				 :class="{'text-right': rableTitle[z_ndex].text_right}"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{item[z_tem.type]*100 | tableToFixed}}%
				</div>
				<div v-else-if="z_ndex > sticky_index && z_tem.show_control && x_table_control.indexOf(z_tem.type) > -1" class="table-td-cell"
				 :class="{'text-right': rableTitle[z_ndex].text_right}"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{item[z_tem.type] | tableToFixed}}
				</div>
				<div v-else-if="z_ndex > sticky_index && z_tem.show_control && y_table_control.indexOf(z_tem.type) > -1" class="table-td-cell"
				 :class="{'text-right': rableTitle[z_ndex].text_right}"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{item[z_tem.type]}}
				</div>
				<!-- 广告审核状态 -->
				<div v-else-if="z_ndex > sticky_index && z_tem.show_control && z_tem.type == 'status'" 
				class="table-td-cell" :style="{'width': rableTitle[z_ndex].width + 'px'}">
					{{item.status | pmSatatus}}
				</div>
				<!-- 计划回传比例 -->
				<div v-else-if="z_ndex > sticky_index && z_tem.show_control && z_tem.type == 'report_config'" 
				class="table-td-cell" :style="{'width': rableTitle[z_ndex].width + 'px'}"
				@click="setPlanHc(item)" style="cursor: pointer;color: rgb(98, 168, 234);">
					<div v-if="item.report_config" style="display: flex;flex-wrap: wrap;align-items: center;">
						<div v-if="item.report_config.status == 1" style="margin-right: 7px;flex-shrink: 0;">
							<!-- 已启用 -->
							<a-tag color="green">已启用</a-tag>
						</div>
						<div v-else style="flex-shrink: 0;margin-right: 7px;">
							<!-- 未启用 -->
							<a-tag>未启用</a-tag>
						</div>
						
						<template v-if="item.report_config.report_per_type == 1">
							<div>
								固定序列
							</div>
							<div style="width: 100%;height: 5px;"></div>
							<div>回传比例：{{item.report_config.report_per}}</div>
							<div style="margin-left: 10px;">回传最低金额：{{item.report_config.report_money_limit || 0}}</div>
						</template>
						<template v-else-if="item.report_config.report_per_type == 2">
							<div>自定义序列</div>
						</template>
					</div>
					<div v-else>
						未设置
					</div>
				</div>
				<!-- 落地页回传比例 -->
				<div v-else-if="z_ndex > sticky_index && z_tem.show_control && z_tem.type == 'link.report_per'" 
				class="table-td-cell" :style="{'width': rableTitle[z_ndex].width + 'px'}">
					<div v-if='item.link'>{{item.link.report_per}}</div>
				</div>
				<!-- 落地页ID -->
				<div v-else-if="z_ndex > sticky_index && z_tem.show_control && z_tem.type == 'link_id'" 
				class="table-td-cell" :style="{'width': rableTitle[z_ndex].width + 'px'}">
					<div v-if="item.link_id">{{item.link_id}}</div>
				</div>
				<!-- 投手 -->
				<div v-else-if="z_ndex > sticky_index && z_tem.show_control && z_tem.type == 'admin_list'" 
				class="table-td-cell" :style="{'width': rableTitle[z_ndex].width + 'px'}">
					<div v-if="item.admin_list.length > 0" style="display: flex;align-items: center;flex-wrap: wrap;">
						<div v-for="(item,index) in item.admin_list" :key="index" style="margin: 0 10px 5px 0;">
							{{item.admin_name}}
						</div>
					</div>
				</div>
			</template>
			
		</div>
		
		
		<div v-show="tableShowData.length === 0" style="text-align: center;margin: 80px 0 50px;" :style="{'width': table_null_width + 'px'}">
			<a-icon style="font-size: 70px;color: #999;" type="file-search" />
			
			<div style="color: #999;font-size: 16px;margin-top: 20px;">内容为空</div>
		</div>
		
		
		<div style="position: fixed;right: 0;bottom:0;z-index: 6;background-color: #fff;height: 90vh;width: 30px;"></div>
		<div style="position: fixed;left: 0;bottom:0;z-index: 6;background-color: #fff;height: 90vh;width: 30px;"></div>
		
		
	</div>
</template>

<script>
export default {
	name: 'JLpromotionTable',
	props: ['rableTitle','tableShowData','tableSumData','table_scroll_width','jj_checked','indeterminate','checkAll','table_null_width',],
	data(){
		return {
			
			select_sort_index: "", // 筛选的
			
			popover_clicked: false,
			
			sticky_index: 1,
			// 用于总计的不显示控制
			z_table_control: ['status','cpa_bid','report_config','link.report_per','link_id','promotion_id','project_id','project_name','advertiser_id','adv_name','promotion_create_time','promotion_modify_time','admin_list'],
					
			// 表格项要进行百分比展示的
			b_table_control: ['eff_roi','eff_roi_first'],
			// 表格项要进行小数点后两位
			x_table_control: ['active_cost','lp_price','eff_total_pay_user_cost','arpu','eff_report_pay_user_cost'],
			// 表格项不进行任何处理直接展示的-一般为文字内容
			y_table_control: ['cpa_bid','promotion_id','project_id','project_name','advertiser_id','adv_name','promotion_create_time','promotion_modify_time'],
		}
	},
	methods: {
		sortClick(index){ // 点击表头给内容进行排序
			let that = this
			let th_status // 0是默认，1是箭头向下，2是箭头向上
			console.log(that.rableTitle[index].type)
			if(that.rableTitle[index].sort_control){ // 是否有排序功能
				if(index !== this.select_sort_index){
					this.select_sort_index = index
					that.rableTitle.forEach(res=>{
						res.sort_status = 0
					})
					that.rableTitle[index].sort_status = 1
					th_status = 1
				}
				else { // 点击的是同一个表头
					if(that.rableTitle[index].sort_status === 0){
						that.rableTitle[index].sort_status = 1 // 箭头向下
						th_status = 1
					}
					else if(that.rableTitle[index].sort_status === 1){
						that.rableTitle[index].sort_status = 2 // 箭头向上
						th_status = 2
					}
					else if(that.rableTitle[index].sort_status === 2){
						that.rableTitle[index].sort_status = 0
						th_status = 0
					}
				}
				
				this.$emit('table-th-click', index, th_status, that.rableTitle[index].type)
			}
		},
		// editTable(index){
		// 	this.$emit('edit-td-click', index)
		// },
		
		// 操作
		operation(e,item){
			console.log(e,item)
			if(e == 1){ // 点击账户名称
				// 这里使用params方式传参，而不用query是因为，params的参数不会拼在url后面，这样子刷新页面后，传过来的参数就可以自动清空
				// this.$router.replace({name: 'JLcy_',params: {jump_id: item.plan_id}})
			}
			
		},
		handleClickChange(e,item){
			console.log(e)
			item.popover_clicked = e
		},
		// 表格内的操作项
		zhOperation(e,item){
			item.popover_clicked = false
			if(e == 1){ // 同步账户信息
				
				this.$emit('sync-zhxx-click', item)
			}
			else if(e == 8){ // 小时数据
				this.$emit('td-handle', 8, item)
			}
			else if(e == 9){ // 天数据
				this.$emit('td-handle', 9, item)
			}
		},
		
		// 全选
		onCheckAllChange(e){
			this.$emit('click-All-Checkbox', e)
		},
		// 单选
		onChangeCheckbox(checkedList,index){
			this.$emit('click-Checkbox', checkedList,index)
		},
		
		// 操作项的开关
		onStatusCheckbox(e,item){ // 启用或暂停
			// console.log(e,item);
			// this.$emit('status-Checkbox', e, item)
		},
		
		// 设置计划回传比例
		setPlanHc(item){
			// console.log(item);
			this.$emit('set-Plan-Hcbl', item)
		}
	},
	filters: {
		tableToFixed(value){ // 保留小数点后两位，四舍五入
			// console.log("过滤器",value)
			if(value){
				let v = Number(value)
				return v.toFixed(2)
			}
			else {
				return 0
			}
			
		},
		// 广告审核状态过滤
		pmSatatus(value){
			// console.log("广告审核状态过滤---",value)
			let ppp = ''
			switch(value)
			{
			    case "NOT_DELETED":
			        ppp = "不限"
			        break;
			    case "ALL":
					ppp = "不限（包含已删除）"
			        break;
				case "OK":
					ppp = "投放中"
				    break;
				case "DELETED":
					ppp = "已删除"
				    break;
				case "PROJECT_OFFLINE_BUDGET":
					ppp = "项目超出预算"
				    break;
				case "PROJECT_PREOFFLINE_BUDGET":
					ppp = "项目接近预算"
				    break;
				case "TIME_NO_REACH":
					ppp = "未到达投放时间"
				    break;
				case "TIME_DONE":
					ppp = "已完成"
				    break;
				case "NO_SCHEDULE":
					ppp = "不在投放时段"
				    break;
				case "AUDIT":
					ppp = "新建审核中"
				    break;
				case "REAUDIT":
					ppp = "修改审核中"
				    break;
				case "FROZEN":
					ppp = "已终止"
				    break;
				case "AUDIT_DENY":
					ppp = "审核不通过"
				    break;
				case "OFFLINE_BUDGET":
					ppp = "广告超出预算"
				    break;
				case "OFFLINE_BALANCE":
					ppp = "账户余额不足"
				    break;
				case "PREOFFLINE_BUDGET":
					ppp = "广告接近预算"
					break;
				case "DISABLED":
					ppp = "已暂停"
					break;
				case "PROJECT_DISABLED":
					ppp = "已被项目暂停"
					break;
				case "LIVE_ROOM_OFF":
					ppp = "关联直播间不可投"
					break;
				case "PRODUCT_OFFLINE":
					ppp = "关联商品不可投"
					break;
				case "AWEME_ACCOUNT_DISABLED":
					ppp = "关联抖音账号不可投"
					break;
				case "AWEME_ANCHOR_DISABLED":
					ppp = "锚点不可投"
					break;
				case "DISABLE_BY_QUOTA":
					ppp = "已暂停（配额达限）"
					break;
			    default:
			        ppp = "无"
			}
			// console.log("广告审核状态过滤器")
			return ppp
		}
	}
}
</script>

<style scoped>
.cz-button-calss {
	font-size: 13px;
	padding:10px;
	cursor: pointer;
}
.cz-button-calss:hover {
	background-color: #f4f7fa;
}

.cz-cell {
	color: #62a8ea;
	cursor: pointer;
	/* margin-right: 7px; */
	/* margin-top: 5px; */
}
.cz-cell:hover{
	color: rgb(47, 136, 255);
}

/* 表格样式-非公共/基础样式 */
.table-th-cell {
	height: 59px;
}
.table-th-cell:hover {
	background-color: #eee;
}
.table-th-cell:hover .table-th-cell-sticky{
	background-color: #eee;
}

.table-td-cell {
	font-size: 12px;
}
</style>